import React from "react";
import {noop} from "lodash";
import Option from "./Option";
import {CommonProps} from "../types";

type NoOptionsProps = CommonProps & {
  children: React.ReactNode;
};

const NoOptionsMessage = ({
  children,
  ...props
}: NoOptionsProps): JSX.Element => (
  <Option
    {...props}
    disabled
    id="dropdown-no-options-message"
    index={-1}
    onClick={noop}
    onMouseMove={noop}
  >
    {children}
  </Option>
);

export default NoOptionsMessage;
